/* Patch: free shipping bar text updater */
(function () {
  function formatBRL(cents) {
    var v = (Math.abs(parseFloat(cents) || 0) / 100).toFixed(2).replace('.', ',');
    return 'R$\u00a0' + v;
  }
  function update(detail) {
    var bars = document.querySelectorAll('free-shipping-bar');
    if (!bars.length) return;
    var total = parseFloat((detail && detail.cart && detail.cart.total_price) || 0);
    bars.forEach(function (bar) {
      var threshold = parseFloat(bar.getAttribute('threshold') || '0');
      var textEl = bar.querySelector('.shipping-bar__text');
      if (!textEl) return;
      if (total >= threshold) {
        textEl.textContent = 'Parab\u00e9ns, voc\u00ea ganhou Frete Gr\u00e1tis!';
      } else {
        var remaining = threshold - total;
        textEl.textContent = 'Faltam ' + formatBRL(remaining) + ' para ganhar frete gr\u00e1tis!';
      }
    });
  }
  document.documentElement.addEventListener('cart:updated', function (e) {
    update(e.detail || {});
  });
})();
